"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBookingStatus = void 0;
var client_1 = require("@apollo/client");
var booking_1 = require("../ressources/graph/mutations/booking");
var booking_2 = require("../ressources/graph/queries/booking");
var useBookingStatus = function () {
    var _a = (0, client_1.useMutation)(booking_1.UPDATE_BOOKING_STATUS, {
        update: function (cache, _a) {
            var updateBookingStatusData = _a.data;
            if (updateBookingStatusData) {
                var booking_3 = updateBookingStatusData.updateBookingStatus;
                // read data from cache
                var cachedBookings = cache.readQuery({ query: booking_2.GET_BOOKINGS });
                if (cachedBookings) {
                    var bookings = cachedBookings.bookings;
                    var filteredTodos = bookings.filter(function (currentTodo) { return currentTodo.id !== booking_3.id; });
                    cache.writeQuery({
                        query: booking_2.GET_BOOKINGS,
                        data: { bookings: __spreadArray(__spreadArray([], filteredTodos, true), [booking_3], false) },
                    });
                }
                else {
                    cache.writeQuery({
                        query: booking_2.GET_BOOKINGS,
                        data: { bookings: [booking_3] },
                    });
                }
            }
        },
    }), updateBookingStatus = _a[0], _b = _a[1], updateBookingStatusInProgress = _b.loading, updateBookingStatusError = _b.error;
    return {
        updateBookingStatus: updateBookingStatus,
        updateBookingStatusInProgress: updateBookingStatusInProgress,
        updateBookingStatusError: updateBookingStatusError,
    };
};
exports.useBookingStatus = useBookingStatus;
